import { ArrowRightIcon } from "@/components/DirectionsIcons";
import { customEvent } from "goi_common";
import { useState } from "react";
import { DirectionsChecklistModal } from "./DirectionsChecklistModal";

interface DirectionsIntentBridgeProps {
  parlorId: number;
  companyName: string;
}

export const DirectionsIntentBridge = ({
  parlorId,
  companyName,
}: DirectionsIntentBridgeProps) => {
  const [isChecklistOpen, setIsChecklistOpen] = useState(false);
  const fullRequestHref = `${process.env.NEXT_PUBLIC_PLATFORM_WEB_URL}/match/parlor-requests/${parlorId}/?utm_source=parlor_goi&utm_campaign=directions&utm_content=full_request`;

  return (
    <div className="dr-intent-band">
      <section className="dr-intent" aria-labelledby="dr-intent-title">
        <div className="dr-intent__eyebrow">장례를 준비하고 계시다면?</div>
        <h2 id="dr-intent-title" className="dr-intent__title">
          <b>비용, 절차, 할인까지 한번에</b>
        </h2>
        <p className="dr-intent__lede">
          <b>장례식장 이용</b>이 필요하시거나 <b>장례 준비</b>를 하고 계시다면,{" "}
          <b>무료 비용 견적을 받아보세요.</b>
        </p>

        <a
          className="dr-intent__full"
          href={fullRequestHref}
          onClick={() =>
            customEvent({
              newGtm: {
                path: "prlr_directions",
                trigger_and_target: "i_full",
                properties: {
                  parlor_id: parlorId,
                  cta_type: "full_request",
                  cta_position: "intent_bridge",
                },
              },
            })
          }
        >
          <span>
            <strong>비용,절차,할인까지 한번에 알아보기</strong>
            <small>{`${companyName} 포함 맞춤 장례식장 견적`}</small>
          </span>
          <ArrowRightIcon size={18} />
        </a>

        <button
          type="button"
          className="dr-intent__prepare"
          onClick={() => {
            customEvent({
              newGtm: {
                path: "prlr_directions",
                trigger_and_target: "i_checklist_open",
                properties: {
                  parlor_id: parlorId,
                  cta_position: "intent_bridge",
                },
              },
            });
            setIsChecklistOpen(true);
          }}
        >
          <span className="dr-intent__phone-cta">
            <strong>임종 준비 체크리스트 받아보기</strong>
            <span className="dr-intent__phone-divider" aria-hidden="true" />
            <span className="dr-intent__phone">무료</span>
          </span>
        </button>
      </section>
      <DirectionsChecklistModal
        isOpen={isChecklistOpen}
        onClose={() => setIsChecklistOpen(false)}
        parlorId={parlorId}
      />
    </div>
  );
};
